import { Close } from '@material-ui/icons';
import clsx from 'clsx';
import BottomPopupWidget from 'component/bottom_popup';
import ButtonCheckout from 'component/customize_button/button_checkout';
import FilterCategoryWidget from 'component/header-filter/filter_category_widget';
import FilterCommonWidget from 'component/header-filter/filter_common_widget';
import FilterPriceRangeWidget from 'component/header-filter/filter_price_range_widget';
import FilterWidget from 'component/header-filter/filter_widget';
import PurposeSuggestionWidget from 'component/header-filter/purpose_suggestion_widget';
import SortWidget from 'component/header-filter/sort_widget';
import FilterConsumer from 'containers/my_styles_my_items/filter_consumer';
import ViewStyleDetail from 'containers/style_detail/view_style_detail';
import ViewInfomationStyle from 'containers/style_detail/view_style_information';
import { UserType } from 'graph_ql/users/types';
import { useEffect, useState } from 'react';
import { use100vh } from 'react-div-100vh';
import { useDispatch, useSelector } from 'react-redux';
import { changeTriggerUpdateSearch } from 'redux/filter/filterSlice';
import { RootState } from 'redux/store';
import { trackEvent, TRACK_EVENT } from 'utils/analytics';
import { getProductTrackingData } from 'utils/trackUtils';
import { WidgetCode } from './constant';
import { useStyles } from './style';
import SearchConsumer from 'containers/create-style/AddOrSelectItem/SearchConsumer';
import SearchStore from 'containers/create-style/AddOrSelectItem/SearchStore';
import { StyleResponse } from 'containers/session_details/type';
import utils from 'utils/utils';
import PreviewImage from 'containers/chat/previewImage';
import ConsumerFeedbacks from 'component/style_item/ConsumerFeedbacks';
import Signup from 'containers/authentication/SignUp/Signup';
import { LanguageCode } from '__generated__/globalTypes';
import langUtils from '../../containers/language/utils';
import CreateProfile from 'containers/chat/CreateProfile';
import constant from 'utils/constant';
import Drawer from '@material-ui/core/Drawer';
import { useVisualViewport } from '../../utils/useVisaulViewport';

export interface WidgetPopupProps {
    isOpen?: boolean;
    listItem?: any[];
    setListItem?: (listItem) => void;
    onClose: () => void;
    onRedirect?: () => void;
    widgetCode?: WidgetCode | null;
    titlePopup: String;
    isButton?: Boolean;
    isButtonWhite?: Boolean;
    titleButton?: String;
    shortPopup?: Boolean;
    handleClick?: any;
    infoItem?: any;
    pageCode?: String;
    loading?: Boolean;
    listOptions?: any[];
    infoStyle?: any;
    widgetProps?: any;
    styleData?: StyleResponse;
    isFullScreen?: boolean;
    hideHeader?: boolean;
    language?: string;
    drawerVariant?: 'temporary' | 'permanent' | 'persistent' | undefined;
    customWidgetProps?: any;
}

const WidgetPopup = ({
    isOpen = true,
    listItem,
    setListItem,
    onClose,
    onRedirect = () => {},
    isFullScreen = false,
    hideHeader = false,
    widgetCode,
    titlePopup,
    isButton,
    isButtonWhite,
    titleButton,
    shortPopup,
    handleClick,
    infoItem,
    pageCode,
    loading,
    listOptions,
    infoStyle,
    widgetProps,
    styleData,
    language = LanguageCode.english,
    drawerVariant,
    customWidgetProps,
}: WidgetPopupProps) => {
    const dispatch = useDispatch();
    const windowSize = useVisualViewport();
    const classes = useStyles();
    const [isShortHeight, setIsShortHeight] = useState(shortPopup);
    const [heightContent, setHeightContent] = useState<any>();
    const [triggerUpdateSearch, setTriggerUpdateSearch] = useState(false);
    let disabledAddItem = false;
    const userDetail = useSelector((state: RootState) => state.userDetail.me);

    useEffect(() => {
        let shortHeight =
            widgetCode === WidgetCode.GenderFilterWidget ||
            widgetCode === WidgetCode.PriceRangeFilterWidget ||
            widgetCode === WidgetCode.BodyShapeFilterWidget ||
            widgetCode === WidgetCode.BodyTypeFilterWidget ||
            widgetCode === WidgetCode.BrandsFilterWidget;
        if (shortHeight) {
            setIsShortHeight(true);
        }
    }, [widgetCode]);

    const renderContent = (code) => {
        switch (code) {
        case WidgetCode.ViewDetailStyle:
            disabledAddItem = !isShortHeight && listItem?.reduce((pr, cr) => pr + (cr?.quantity || 0), 0) <= 0;
            return (
                <ViewStyleDetail
                    listItem={listItem}
                    setListItem={setListItem}
                    shortPopup={isShortHeight}
                    styleData={styleData}
                    onOpenItem={handleClick}
                    language={language}
                    {...(customWidgetProps?.hideButtonOnFirstItem ? customWidgetProps : {})}
                />
            );
        case WidgetCode.FilterWidget:
            return <FilterWidget setTriggerUpdateSearch={setTriggerUpdateSearch} />;
        case WidgetCode.GenderFilterWidget:
            return (
                <FilterCommonWidget
                    type={WidgetCode.GenderFilterWidget}
                    setTriggerUpdateSearch={setTriggerUpdateSearch}
                />
            );
        case WidgetCode.CategoryFilterWidget:
            return <FilterCategoryWidget setTriggerUpdateSearch={setTriggerUpdateSearch} />;
        case WidgetCode.PriceRangeFilterWidget:
            return <FilterPriceRangeWidget setTriggerUpdateSearch={setTriggerUpdateSearch} />;
        case WidgetCode.SortWidget:
            return <SortWidget setTriggerUpdateSearch={setTriggerUpdateSearch} />;
        case WidgetCode.BottomPopupWidget:
            return <BottomPopupWidget listItem={listItem} />;
        case WidgetCode.ViewStyleInfo:
            return <ViewInfomationStyle item={infoItem} pageCode={pageCode} />;
        case WidgetCode.BodyShapeFilterWidget:
            return (
                <FilterCommonWidget
                    type={WidgetCode.BodyShapeFilterWidget}
                    setTriggerUpdateSearch={setTriggerUpdateSearch}
                />
            );
        case WidgetCode.BodyTypeFilterWidget:
            return (
                <FilterCommonWidget
                    type={WidgetCode.BodyTypeFilterWidget}
                    setTriggerUpdateSearch={setTriggerUpdateSearch}
                />
            );
        case WidgetCode.ExpertiseFilterWidget:
            return (
                <FilterCommonWidget
                    type={WidgetCode.ExpertiseFilterWidget}
                    setTriggerUpdateSearch={setTriggerUpdateSearch}
                />
            );
        case WidgetCode.LevelFilterWidget:
            return (
                <FilterCommonWidget
                    type={WidgetCode.LevelFilterWidget}
                    setTriggerUpdateSearch={setTriggerUpdateSearch}
                />
            );
        case WidgetCode.PurposeFilterWidget:
            return (
                <FilterCommonWidget
                    type={WidgetCode.PurposeFilterWidget}
                    setTriggerUpdateSearch={setTriggerUpdateSearch}
                />
            );
        case WidgetCode.PurposeSuggestionWidget:
            return (
                <PurposeSuggestionWidget
                    listOptions={listOptions}
                    setTriggerUpdateSearch={setTriggerUpdateSearch}
                />
            );
        case WidgetCode.FilterConsumerWidget:
            return <FilterConsumer {...widgetProps} />;
        case WidgetCode.SearchConsumerWidget:
            return <SearchConsumer {...widgetProps} />;
        case WidgetCode.BrandsFilterWidget:
            return (
                <FilterCommonWidget
                    type={WidgetCode.BrandsFilterWidget}
                    setTriggerUpdateSearch={setTriggerUpdateSearch}
                />
            );
        case WidgetCode.SearchStoreWidget:
            return <SearchStore {...widgetProps} />;
        case WidgetCode.PreviewImage:
            return <PreviewImage {...widgetProps} heightContent={heightContent} handleClose={handleClose} />;
        case WidgetCode.ConsumerFeedback:
            return <ConsumerFeedbacks {...widgetProps} />;
        case WidgetCode.AuthWidget:
            return <Signup {...widgetProps} onRedirect={onRedirect} />;
        case WidgetCode.CreateProfile:
            return <CreateProfile {...widgetProps} />;
        default:
            console.error('renderContent: unexpected code=', code);
            return <></>;
        }
    };
    const height: any = use100vh();
    useEffect(() => {
        const heightTitle = document.getElementById('title')?.offsetHeight;
        const calculatedHeight = isFullScreen
            ? height - 109
            : utils.isAppInWidgetMode()
                ? (height * 80) / 100
                : height - 26;
        setHeightContent(
            calculatedHeight -
                (pageCode === constant.PAGE_CODE.CHAT && !isFullScreen ? 56 : 0) -
                (isButton ? 44 : 0) -
                (heightTitle ? heightTitle : 0),
        );
    }, [height, isButton, isFullScreen, hideHeader, pageCode]);

    const handleClose = () => {
        if (triggerUpdateSearch) {
            dispatch(changeTriggerUpdateSearch(true));
        }

        if (
            (widgetCode === WidgetCode.ViewStyleInfo || widgetCode === WidgetCode.ViewDetailStyle) &&
            userDetail?.userType === UserType.customer
        ) {
            trackEvent(TRACK_EVENT.PRODUCT_INFO_CLOSE, getProductTrackingData(userDetail, infoItem, infoStyle));
        }
        onClose();
    };

    return (
        <Drawer
            open={Boolean(isOpen)}
            onClose={onClose}
            anchor={'bottom'}
            variant={drawerVariant ?? 'temporary'}
            PaperProps={{
                className: classes.wrapper,
                style: {
                    marginLeft: windowSize.viewport.width > 1024 ? -512 : -0.5 * windowSize.viewport.width,
                },
            }}
        >
            <div className={classes.main}>
                <div
                    className={classes.popupClose}
                    style={{
                        height: '100%',
                    }}
                    onClick={handleClose}
                />
                <div
                    className={classes.popupMain}
                    style={{
                        height: `${
                            utils.isAppInWidgetMode()
                                ? isFullScreen
                                    ? 'auto'
                                    : '80%'
                                : isShortHeight
                                    ? 'auto'
                                    : '100%'
                        }`,
                        minHeight: widgetCode !== WidgetCode.BottomPopupWidget ? '285px' : '',
                        maxHeight: isFullScreen ? 'calc(100% - 109px)' : 'calc(100% - 26px)',
                        background: widgetCode === WidgetCode.PreviewImage ? '#ffffff' : '#f2f2f2',
                        padding: isFullScreen ? '0px' : '0 24px 0 24px',
                    }}
                >
                    {!hideHeader ? (
                        !isFullScreen ? (
                            <div className={classes.popupTitle} id="title">
                                <span
                                    className={clsx(
                                        classes.popupTitleText,
                                        widgetCode === WidgetCode.BottomPopupWidget && classes.bottomPopupTitleText,
                                    )}
                                    style={{ ...langUtils.getLanguageStyle(language) }}
                                >
                                    {titlePopup}
                                </span>
                                <Close className={classes.popupTitleIcon} onClick={handleClose} />
                            </div>
                        ) : (
                            <Close
                                className={`${classes.popupTitleIconLight} ${classes.customCloseIcon}`}
                                onClick={handleClose}
                            />
                        )
                    ) : null}
                    <div
                        className={classes.popupContent}
                        style={{
                            maxHeight: `${heightContent}px`,
                            paddingBottom: `${isFullScreen ? 0 : isButton ? 44 : 0}px`,
                        }}
                    >
                        {renderContent(widgetCode)}
                    </div>
                    {isButton && (
                        <>
                            {!isShortHeight && (
                                <div
                                    style={{
                                        background: 'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%)',
                                        position: 'absolute',
                                        height: 40,
                                        bottom: 68,
                                        zIndex: 200,
                                        width: '100%',
                                        padding: '0 24px',
                                        left: 0,
                                        right: 0,
                                    }}
                                />
                            )}

                            <div
                                style={{
                                    padding: '0 24px 24px 24px',
                                    position: 'absolute',
                                    bottom: 0,
                                    width: '100%',
                                    left: 0,
                                    right: 0,
                                    background: 'white',
                                }}
                            >
                                <ButtonCheckout
                                    loading={loading}
                                    disabled={disabledAddItem}
                                    handleClick={() => handleClick(listItem)}
                                    title={titleButton}
                                    isWhite={isButtonWhite}
                                />
                            </div>
                        </>
                    )}
                </div>
            </div>
        </Drawer>
    );
};

export default WidgetPopup;
